import React from 'react'
import { useAuth } from '../../context/AuthContext'
import SoloProviderDashboard from './SoloProviderDashboard'
import GroupPracticeDashboard from './GroupPracticeDashboard'
import ClinicDashboard from './ClinicDashboard'

/** The single wrapper the /practice route renders — picks Solo/Group/Clinic
 * by organization_type instead of one shared dashboard with hidden buttons.
 * Enterprise has no self-service dashboard yet (Phase 1 signup flow caps at
 * clinic), so Clinic is the safe fallback if it's ever reached. */
export default function OrgDashboardRouter() {
  const { me } = useAuth()

  switch (me?.organization_type) {
    case 'solo_provider':
      return <SoloProviderDashboard />
    case 'group_practice':
      return <GroupPracticeDashboard />
    case 'clinic':
    case 'enterprise':
      return <ClinicDashboard />
    default:
      return <GroupPracticeDashboard />
  }
}
